// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../../assets/stylesheets/variables.css\"","caption":"_1dJD2pSCq2-UhXWE_3mRfd","subheader":"_3tfkBLzh4oNF67_ojQV2Pn","primaryGreen":"#028154","extraSmallMinWidth":"576px","extraSmallMaxWidth":"767px","smallMinWidth":"768px","image":"vpWm1Jc6VuNrIrd3mtUJf","mobileImage":"_21k6-7WKFTU7VEcogw_BpO","brand":"_3r2zXU6fJSRxIhKCE-Z3_5 _1dJD2pSCq2-UhXWE_3mRfd","name":"_3E50exEgay8GT7Ln6AQraO _3tfkBLzh4oNF67_ojQV2Pn","price":"_12e6zTXJacEteW4yLAOAkY _3tfkBLzh4oNF67_ojQV2Pn","container":"_32EhAcu28pm_wDXiIPNvXz"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/compare/product-summary/ProductSummary.css
// module id = 1093
// module chunks = 1